<template>
    <ContentPanel
        :headline="t('transformers.conditionStatus.content.oilHistoricalTrends.title')"
        :hide-content="!isFullOilSelection || !hasOilChartData"
    >
        <template v-if="!isFullOilSelection || !hasOilChartData" #context>
            <ColorBadge
                :color="StatusTypes[ConditionStatus.None].color"
                :text="t(StatusTypes[ConditionStatus.None].labelKey)"
                small
            />
        </template>
        <ConditionStatusOilHistoricalTrendsChart
            v-if="isFullOilSelection"
            :start-date="oilSelection.startDate"
            :end-date="oilSelection.endDate"
            :gas-in-oil-parameter-group="oilSelection.gasInOilParameterGroup"
            :force-light-theme="isPdfLightTheme"
            hide-toolbox
            @update:has-data="onUpdateOilChartHasData"
        />
    </ContentPanel>
</template>

<script setup lang="ts">
import ContentPanel from '@/components/panel/ContentPanel.vue'
import ColorBadge from '@/components/badge/ColorBadge.vue'
import ConditionStatusOilHistoricalTrendsChart from '@/pages/transformers/condition-status/sections/oil-historical-trends/ConditionStatusOilHistoricalTrendsChart.vue'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { OilHistoricalTrendsSelector } from '@/pages/transformers/condition-status/sections/oil-historical-trends/oil-historical-trends-types'
import { ConditionStatus, StatusTypes } from '@/configuration/status/condition-status'
import { useExportPdfLightTheme } from '@/pages/exports/useExportPdfTheme'

const { t } = useI18n()
const { query } = useRoute()

const hasOilChartData = ref(true)
const isPdfLightTheme = useExportPdfLightTheme()

const oilSelection = computed<OilHistoricalTrendsSelector>(() => {
    const gasInOilParameterNumber = parseInt(query.gasInOilParameterGroup as string)

    return {
        startDate: query.startDate as string | undefined,
        endDate: query.endDate as string | undefined,
        gasInOilParameterGroup: isNaN(gasInOilParameterNumber)
            ? (query.gasInOilParameterGroup as string | undefined)
            : gasInOilParameterNumber,
    }
})

const isFullOilSelection = computed<boolean>(() => {
    return !!oilSelection.value.startDate && !!oilSelection.value.endDate && !!oilSelection.value.gasInOilParameterGroup
})

const onUpdateOilChartHasData = (value: boolean) => (hasOilChartData.value = value)
</script>